import React, { useEffect, useRef, useState } from 'react';
import { Z_TOPBAR_MENU, Z_TOPBAR_MENU_AWAY } from './layers';   // 5.49.1 above the HealthSherpa lock strip

// 5.23.0: the one top-bar dropdown (+ New ▾, Admin ▾), extracted from the inline Telecom ▾ /
// user-menu pattern (Telecom ▾ itself is left exactly as it was). Click toggles; a click-away layer
// and Esc close; Enter / Space / ArrowDown on the button open it and focus the first item; Up / Down
// move, Home / End jump, Esc closes and returns focus to the button, Tab closes. Items are already
// filtered by role by the caller (an empty list renders nothing).
export default function TopMenu({ label, items, dot = null, buttonStyle, width, theme, title, testId }) {
  const [open, setOpen] = useState(false);
  const btnRef = useRef(null);
  const itemRefs = useRef([]);
  const { panelBg, borderColor, textPrimary } = theme;

  useEffect(() => { if (!open) itemRefs.current = []; }, [open]);
  if (!items || items.length === 0) return null;

  const focusItem = (i) => {
    const n = items.length;
    const el = itemRefs.current[((i % n) + n) % n];
    if (el) el.focus();
  };
  const openAndFocus = () => { setOpen(true); setTimeout(() => focusItem(0), 0); };
  const close = (returnFocus) => { setOpen(false); if (returnFocus && btnRef.current) btnRef.current.focus(); };

  const onButtonKey = (e) => {
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'ArrowDown') { e.preventDefault(); openAndFocus(); }
    else if (e.key === 'Escape' && open) { e.preventDefault(); close(true); }
  };
  const onMenuKey = (e) => {
    const i = itemRefs.current.indexOf(document.activeElement);
    if (e.key === 'ArrowDown') { e.preventDefault(); focusItem(i + 1); }
    else if (e.key === 'ArrowUp') { e.preventDefault(); focusItem(i - 1); }
    else if (e.key === 'Home') { e.preventDefault(); focusItem(0); }
    else if (e.key === 'End') { e.preventDefault(); focusItem(items.length - 1); }
    else if (e.key === 'Escape') { e.preventDefault(); close(true); }
    else if (e.key === 'Tab') { setOpen(false); }
  };

  return (
    <div style={{ position: 'relative', display: 'inline-flex' }}>
      <button ref={btnRef} type="button" data-topbtn="1" data-testid={testId}
        aria-haspopup="menu" aria-expanded={open} title={title}
        onClick={() => setOpen((o) => !o)} onKeyDown={onButtonKey}
        onKeyUp={(e) => { if (e.key === ' ') e.preventDefault(); }}
        style={{ ...buttonStyle, width }}>
        <span data-lbl="1" style={{ display: 'inline-flex', alignItems: 'center', gap: 7, whiteSpace: 'nowrap' }}>{label}{dot}</span>
      </button>
      {open && (
        <>
          <div data-testid={testId ? `${testId}-away` : undefined} onClick={() => setOpen(false)}
            style={{ position: 'fixed', inset: 0, zIndex: Z_TOPBAR_MENU_AWAY }} />
          <div role="menu" onKeyDown={onMenuKey}
            style={{ position: 'absolute', top: '100%', left: 0, marginTop: 6, zIndex: Z_TOPBAR_MENU, background: panelBg, border: `1px solid ${borderColor}`, borderRadius: 8, boxShadow: '0 8px 24px rgba(0,0,0,0.18)', minWidth: Math.max(200, width || 0), padding: 4 }}>
            {items.map((it, i) => (
              <button key={it.key} type="button" role="menuitem" ref={(el) => { itemRefs.current[i] = el; }}
                onClick={() => { setOpen(false); it.onClick(); }}
                style={{ display: 'flex', alignItems: 'center', gap: 8, width: '100%', textAlign: 'left', padding: '8px 12px', background: 'none', border: 'none', borderRadius: 6, fontSize: 13, color: textPrimary, cursor: 'pointer', whiteSpace: 'nowrap' }}
                onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(125,125,125,0.15)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = 'none'; }}
                onFocus={(e) => { e.currentTarget.style.background = 'rgba(125,125,125,0.15)'; }}
                onBlur={(e) => { e.currentTarget.style.background = 'none'; }}>
                <span>{it.label}</span>{it.dot || null}
              </button>
            ))}
          </div>
        </>
      )}
    </div>
  );
}
